import ApplicationAdapter from './application';
import DS from 'ember-data';
import { inject as service } from '@ember/service';
import MasqService from 'cio/services/masq';
import AccountService from 'cio/services/account';
import AuthService from 'cio/services/auth';

interface AccountPayload {
  session_expires_at: number;
  account: Record<string, any>;
  user: Record<string, any>;
  environments: Record<string, any>[];
}

export default class AccountAdapter extends ApplicationAdapter {
  @service account!: AccountService;
  @service masq!: MasqService;
  @service auth!: AuthService;

  queryRecord(_store: DS.Store, _type: unknown, query: { environmentID?: string; accountID?: string }) {
    let { environmentID, accountID } = query;

    accountID =
      this.account.current?.id ?? // account is already loaded - always use its ID
      accountID ?? // initial account load, masquerading is on - accountID passed from "authenticated" controller model() method
      'current'; // initial account load, masqueradng off - fetch current user's account

    let url = environmentID
      ? `${this.host}/${this.namespace}/account_by_environment/${environmentID}`
      : this.buildURL('account', accountID);

    return this.ajax(url, 'GET', {});
  }

  handleResponse(
    status: number,
    headers: Record<string, any>,
    payload: AccountPayload,
    requestData: Record<string, any>,
  ) {
    this.auth.updateAccessExpirationCookie(payload?.session_expires_at);
    return super.handleResponse(status, headers, payload, requestData);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    account: AccountAdapter;
  }
}
